import type { StatementStep as StatementStepConfig } from "@/types/offer";
import type { StepRenderProps } from "./types";

// A statement carries no input; the title/description live in the shell and the
// continue button is rendered by the flow. This keeps the renderer switch total.
export function StatementStep(_props: StepRenderProps<StatementStepConfig>) {
  return null;
}
